export default __webpack_public_path__ + "static/media/element_62.58f629b5.webp";